"use client";

import { c as _c } from "react/compiler-runtime";
import { useDebounce } from "@react-hooks-library/core";
import { gql } from "graphql-request";
import { useCallback, useEffect, useReducer, useState } from "react";
import Button from "src/components/button/Button";
import LoadingIndicator from "src/components/loadingindicator/LoadingIndicator";
import MySelectedLocations from "src/components/locationselector/MySelectedLocations";
import SelectorWrapper, { SelectorWrapperHeading } from "src/components/selectorwrapper/SelectorWrapper";
import SearchSvg from "src/components/svg/SearchSvg";
import { useFilminfo } from "src/lib/client/useFilminfo";
import { LocationContext, type LocationContextType, useLocationContext } from "src/lib/contexts/ContextTypes";
import { type Location } from "src/lib/movieinfo/movieinfotypes";
import styles from "./LocationSelector.module.css";
import classNames from "classnames";
import getThemeStyles from "src/lib/styling/getThemeStyles";
import { locale } from "@locale";
const BRAND = process.env.NEXT_PUBLIC_WEBSITE_BRAND;
const SEARCH_QUERY = gql`
	query ($searchText: String) {
		cinemaQuery {
			searchForLocations (searchText: $searchText) {
				__typename
				name
			}
		}
	}
`;
const GEOLOC_QUERY = gql`
	query($lat: Float, $long: Float ) {
    cinemaQuery {
        closestLocations(  latitude: $lat, longitude: $long ) {
            __typename
            name
        }
    }
}
`;

//#region [Props]
type LocationSelectorProps = {
  canUseGeoLocation: boolean;
};
//#endregion

const hotlinkLocations: Location[] = BRAND === "kinodk" ? [{
  name: "Storkøbenhavn"
}, {
  name: "Odense"
}, {
  name: "Aarhus"
}] : [{
  name: "Oslo"
}, {
  name: "Bergen"
}, {
  name: "Trondheim"
}, {
  name: "Stavanger"
}, {
  name: "Sandnes"
}, {
  name: "Sandvika"
}, {
  name: "Lillestrøm"
}, {
  name: "Ski"
}, {
  name: "Drammen"
}, {
  name: "Kristiansand S"
}];

//#region [Component]
export default function LocationSelector(t0) {
  const $ = _c(80);
  const {
    canUseGeoLocation
  } = t0;
  const locationContext = useLocationContext();
  const [searchText, setSearchText] = useState("");
  let t1;
  if ($[0] !== locationContext.location) {
    t1 = locationContext.location ?? [];
    $[0] = locationContext.location;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [currentSelection, setCurrentSelection] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = value => setCurrentSelection(old => old.includes(value) ? old : [...old, value]);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const addLocation = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = value_0 => setCurrentSelection(old_0 => old_0.filter(s => s !== value_0));
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const removeLocation = t3;
  let t4;
  if ($[4] !== searchText) {
    t4 = {
      searchText
    };
    $[4] = searchText;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !!searchText;
  let t6;
  if ($[6] !== t5) {
    t6 = {
      active: t5
    };
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const {
    fiData
  } = useFilminfo(SEARCH_QUERY, t4, t6);
  const geoLoc = useGeolocation(canUseGeoLocation);
  let t7;
  if ($[8] !== fiData?.cinemaQuery?.searchForLocations || $[9] !== geoLoc) {
    t7 = fiData?.cinemaQuery?.searchForLocations ?? (geoLoc ? [] : hotlinkLocations) ?? [];
    $[8] = fiData?.cinemaQuery?.searchForLocations;
    $[9] = geoLoc;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const _locs = t7;
  const t8 = useDebounce(_locs, 400);
  let T0;
  let T1;
  let submitAndClose;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t9;
  if ($[11] !== currentSelection || $[12] !== geoLoc || $[13] !== locationContext || $[14] !== searchText || $[15] !== t8) {
    const locs = t8.filter(_temp);
    let t19;
    if ($[29] !== currentSelection || $[30] !== locationContext) {
      t19 = {
        ...locationContext,
        location: currentSelection,
        setLocation: setCurrentSelection,
        addLocation,
        removeLocation
      };
      $[29] = currentSelection;
      $[30] = locationContext;
      $[31] = t19;
    } else {
      t19 = $[31];
    }
    const innerLocationContext = t19;
    let t20;
    if ($[32] !== currentSelection || $[33] !== locationContext) {
      t20 = () => {
        locationContext.setLocation(currentSelection);
        locationContext.setShowLocationDialog(false);
      };
      $[32] = currentSelection;
      $[33] = locationContext;
      $[34] = t20;
    } else {
      t20 = $[34];
    }
    submitAndClose = t20;
    let t21;
    if ($[35] !== innerLocationContext || $[36] !== locationContext) {
      const searchInputStyles = getThemeStyles(styles);
      T1 = SelectorWrapper;
      if ($[46] !== locationContext) {
        t17 = () => locationContext.setShowLocationDialog(false);
        $[46] = locationContext;
        $[47] = t17;
      } else {
        t17 = $[47];
      }
      t18 = BRAND === "filmweb" ? locale.program.locationHeading : undefined;
      T0 = LocationContext.Provider;
      t16 = innerLocationContext;
      t11 = styles.SLocationSelector;
      if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = <MySelectedLocations className={styles.SResultArea} />;
        t13 = BRAND === "kinodk" && <SelectorWrapperHeading heading={locale.program.locationHeading} />;
        $[48] = t12;
        $[49] = t13;
      } else {
        t12 = $[48];
        t13 = $[49];
      }
      t21 = classNames(styles.ClippedInputContainer, searchInputStyles);
      $[35] = innerLocationContext;
      $[36] = locationContext;
      $[37] = T0;
      $[38] = T1;
      $[39] = t11;
      $[40] = t12;
      $[41] = t13;
      $[42] = t16;
      $[43] = t17;
      $[44] = t18;
      $[45] = t21;
    } else {
      T0 = $[37];
      T1 = $[38];
      t11 = $[39];
      t12 = $[40];
      t13 = $[41];
      t16 = $[42];
      t17 = $[43];
      t18 = $[44];
      t21 = $[45];
    }
    let t22;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = <input name="locationSearch" className={styles.SSearchInput} type="text" placeholder={locale.program.searchLocations} onChange={e => setSearchText(e.target.value)} ref={_temp2} />;
      $[50] = t22;
    } else {
      t22 = $[50];
    }
    let t23;
    if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
      t23 = <div className={styles.SIconPlaceholder}><SearchSvg className={styles.SSearchSvg} useCustomRadialGradient={true} /></div>;
      $[51] = t23;
    } else {
      t23 = $[51];
    }
    if ($[52] !== t21) {
      t14 = <div className={t21}>{t22}{t23}</div>;
      $[52] = t21;
      $[53] = t14;
    } else {
      t14 = $[53];
    }
    if ($[54] !== geoLoc || $[55] !== searchText) {
      t15 = geoLoc && !searchText && <div className={styles.SResultArea}>{geoLoc.isLoading && <LoadingIndicator size="large" position="InlineCenter" />}{!geoLoc.isLoading && <><h5 className={styles.SCloseLocationsHeader}>{locale.program.nearby}:</h5><GeoLocationList locations={geoLoc.locations} /></>}</div>;
      $[54] = geoLoc;
      $[55] = searchText;
      $[56] = t15;
    } else {
      t15 = $[56];
    }
    t9 = styles.SResultArea;
    let t24;
    if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = (loc_0, index) => <Button key={loc_0.name} text={loc_0.name} onClick={() => addLocation(loc_0.name)} className={styles.SResultItem} dkVariant="darkOutline" />;
      $[57] = t24;
    } else {
      t24 = $[57];
    }
    t10 = locs.slice(0, hotlinkLocations.length).map(t24);
    $[11] = currentSelection;
    $[12] = geoLoc;
    $[13] = locationContext;
    $[14] = searchText;
    $[15] = t8;
    $[16] = T0;
    $[17] = T1;
    $[18] = submitAndClose;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
    $[25] = t16;
    $[26] = t17;
    $[27] = t18;
    $[28] = t9;
  } else {
    T0 = $[16];
    T1 = $[17];
    submitAndClose = $[18];
    t10 = $[19];
    t11 = $[20];
    t12 = $[21];
    t13 = $[22];
    t14 = $[23];
    t15 = $[24];
    t16 = $[25];
    t17 = $[26];
    t18 = $[27];
    t9 = $[28];
  }
  let t19;
  if ($[58] !== t10 || $[59] !== t9) {
    t19 = <div className={t9}>{t10}</div>;
    $[58] = t10;
    $[59] = t9;
    $[60] = t19;
  } else {
    t19 = $[60];
  }
  let t20;
  if ($[61] !== submitAndClose) {
    t20 = <div className={styles.SResultArea}><Button className={styles.CloseButton} text={locale.actions.save} onClick={submitAndClose} dkVariant="dark" /></div>;
    $[61] = submitAndClose;
    $[62] = t20;
  } else {
    t20 = $[62];
  }
  let t21;
  if ($[63] !== t11 || $[64] !== t12 || $[65] !== t13 || $[66] !== t14 || $[67] !== t15 || $[68] !== t19 || $[69] !== t20) {
    t21 = <div className={t11}>{t12}{t13}{t14}{t15}{t19}{t20}</div>;
    $[63] = t11;
    $[64] = t12;
    $[65] = t13;
    $[66] = t14;
    $[67] = t15;
    $[68] = t19;
    $[69] = t20;
    $[70] = t21;
  } else {
    t21 = $[70];
  }
  let t22;
  if ($[71] !== T0 || $[72] !== t16 || $[73] !== t21) {
    t22 = <T0 value={t16}>{t21}</T0>;
    $[71] = T0;
    $[72] = t16;
    $[73] = t21;
    $[74] = t22;
  } else {
    t22 = $[74];
  }
  let t23;
  if ($[75] !== T1 || $[76] !== t17 || $[77] !== t18 || $[78] !== t22) {
    t23 = <T1 onClose={t17} heading={t18}>{t22}</T1>;
    $[75] = T1;
    $[76] = t17;
    $[77] = t18;
    $[78] = t22;
    $[79] = t23;
  } else {
    t23 = $[79];
  }
  return t23;
}
//#endregion
function _temp2(input) {
  if (input) {
    input.focus();
  }
}
function _temp(loc) {
  return loc?.name !== "Oslo og omegn";
}
type GeoLocationResult = {
  isLoading: boolean;
  locations: Location[] | undefined;
};
type GeolocationState = {
  isLoading: boolean;
  pos: GeolocationPosition | undefined;
  errorCode: number | undefined;
};
type GeolocationAction = {
  type: "start";
} | {
  type: "success";
  pos: GeolocationPosition;
} | {
  type: "error";
  code: number;
};
function geolocationReducer(state: GeolocationState, action: GeolocationAction): GeolocationState {
  switch (action.type) {
    case "start":
      return {
        isLoading: true,
        pos: undefined,
        errorCode: undefined
      };
    case "success":
      return {
        isLoading: false,
        pos: action.pos,
        errorCode: undefined
      };
    case "error":
      return {
        isLoading: false,
        pos: undefined,
        errorCode: action.code
      };
  }
}
function useGeolocation(canUseGeoLocation) {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      isLoading: false,
      pos: undefined,
      errorCode: undefined
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [geoLocation, dispatchGeoLocation] = useReducer(geolocationReducer, t0);
  let t1;
  let t2;
  if ($[1] !== canUseGeoLocation) {
    t1 = () => {
      if (canUseGeoLocation && typeof window !== "undefined" && "geolocation" in navigator) {
        dispatchGeoLocation({
          type: "start"
        });
        navigator.geolocation.getCurrentPosition(currPos => {
          dispatchGeoLocation({
            type: "success",
            pos: currPos
          });
        }, positionError => {
          if (positionError.code !== positionError.PERMISSION_DENIED) {
            console.warn("Position error", positionError);
          }
          dispatchGeoLocation({
            type: "error",
            code: positionError.code
          });
        }, {
          timeout: 10000
        });
      }
    };
    t2 = [canUseGeoLocation];
    $[1] = canUseGeoLocation;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  const t3 = geoLocation.pos?.coords?.latitude;
  const t4 = geoLocation.pos?.coords?.longitude;
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = {
      lat: t3,
      long: t4
    };
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = canUseGeoLocation && geoLocation.errorCode === undefined && !!geoLocation.pos;
  let t7;
  if ($[7] !== t6) {
    t7 = {
      active: t6
    };
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const {
    fiData,
    fiLoading
  } = useFilminfo(GEOLOC_QUERY, t5, t7);
  if (canUseGeoLocation && geoLocation.errorCode === undefined) {
    const locs = (fiData?.cinemaQuery?.closestLocations?.length ?? 0) === 0 ? undefined : fiData.cinemaQuery.closestLocations as Location[];
    if (locs?.length === 0) {
      return;
    }
    const t8 = fiLoading || geoLocation.isLoading;
    let t9;
    if ($[9] !== locs || $[10] !== t8) {
      t9 = {
        isLoading: t8,
        locations: locs
      };
      $[9] = locs;
      $[10] = t8;
      $[11] = t9;
    } else {
      t9 = $[11];
    }
    return t9;
  }
}
type GeoLocationListProps = {
  locations?: Location[];
};
function GeoLocationList(t0) {
  const $ = _c(8);
  const {
    locations
  } = t0;
  const locationContext = useLocationContext();
  let t1;
  if ($[0] !== locations?.length) {
    t1 = (locations?.length ?? 0) === 0 && <>Ingen kinoer funnet</>;
    $[0] = locations?.length;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== locationContext || $[3] !== locations) {
    t2 = locations?.map((loc, index) => <Button key={loc.name} text={loc.name} onClick={() => locationContext.addLocation(loc.name)} className={styles.SResultItem} dkVariant="darkOutline" />);
    $[2] = locationContext;
    $[3] = locations;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}